/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Signin_NoteInputs */

const en_mcp_connect_signin_note = /** @type {(inputs: Mcp_Connect_Signin_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in doesn’t share anything. You approve access on the next step.`)
};

const es_mcp_connect_signin_note = /** @type {(inputs: Mcp_Connect_Signin_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión no comparte nada. Aprobarás el acceso en el siguiente paso.`)
};

/**
* | output |
* | --- |
* | "Signing in doesn’t share anything. You approve access on the next step." |
*
* @param {Mcp_Connect_Signin_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_signin_note = /** @type {((inputs?: Mcp_Connect_Signin_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Signin_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_signin_note(inputs)
	return en_mcp_connect_signin_note(inputs)
});